import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRepoTemplate } from "./api";
import type { RepoBranchTemplateResponse } from "./api";

// Per-repo override для введённого `owner/repo` (или null = наследует
// org). Запрос отключён без введённого репо (пустую строку на сервер
// не шлём).
export function useRepoTemplate(
  repoFullName: string,
): UseQueryResult<RepoBranchTemplateResponse, Error> {
  return useOrgScopedQuery<RepoBranchTemplateResponse>({
    key: ["branchNameTemplate", "repo", repoFullName],
    queryFn: () => fetchRepoTemplate(repoFullName),
    enabled: repoFullName.length > 0,
    retry: false,
  });
}
